module.exports = __webpack_public_path__ + "img/virtue_mart.6b37e620.png";